module.exports = __webpack_public_path__ + "02_long_brown.5a00dfce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/02_long_brown.png
// module id = WC1H
// module chunks = 0